export const splitDomain = (domain: string) => {
  const numberOfDots = domain.match(/\./g)?.length || 0

  if (numberOfDots === 0) {
    return {
      mainDomain: domain,
      tld: '',
    }
  }

  const mainDomainParts = domain.split('.')
  const tld = mainDomainParts.pop() || ''
  const mainDomain = mainDomainParts.join('.')

  return {
    mainDomain,
    tld,
  }
}
